import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useClientDomainParam } from 'helper/ClientDomainParamParser';

const Head: React.FC = () => {
  const clientDomainParam = useClientDomainParam();

  return (
    <HelmetProvider>
      <Helmet>
        <title>工事台帳管理システム - {clientDomainParam.name}</title>
        <link rel='icon' href={`/image/logo/${clientDomainParam.favicon}`} />
      </Helmet>
    </HelmetProvider>
  );
};

export default Head;
